import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

const Footer = () => (
  <Container className="pt-2 my-4 pt-3 border-top">
    <footer>
      <Container>
        <Row className="justify-content-start">
          <Col xs="12" sm="auto">
            <a
              href="mailto:ja@newslettery.cz"
              target="_blank"
              title="Blogletter"
              rel="noreferrer"
            >
              Napište mi
            </a>
          </Col>
          <Col xs="12" sm="auto">
            <Link to="/privacy">Zásady ochrany osobních údajů</Link>
          </Col>
          <Col xs="12" sm="auto">
            <Link to="/terms">Podmínky užití</Link>
          </Col>
          <Col xs="12" sm="auto">
            <p>&#169; Martin Kavka {new Date().getFullYear()}</p>
          </Col>
        </Row>
        <Row className="justify-content-start">
          <Col xs="12" sm="auto">
            Používáním webu souhlasíte s cookies, které slouží k analýze
            návštěvnosti.
          </Col>
        </Row>
      </Container>
    </footer>
  </Container>
);

export default Footer;
